import { Chart } from "chart.js";
import ChartData from "components/Charts/types/ChartData";

import designTokens from "../../../../../../tokens/design-tokens.json";
import ChartColors from "../../../../../../config/ChartColors";

const createLineChart = (canvas: HTMLCanvasElement, data: ChartData) =>
    new Chart(canvas, {
        type: "line",
        data: {
            labels: data.labels,
            datasets: data.datasets.map(({ label, data, backgroundColor }) => ({
                label,
                data,
                borderWidth: 2,
                borderColor: backgroundColor,
                pointBorderWidth: 2,
                pointBorderColor: backgroundColor,
                pointRadius: 4,
                pointHoverRadius: 4,
                pointBackgroundColor: "#fff",
                tension: 0.4,
            })),
        },
        options: {
            resizeDelay: 500,
            maintainAspectRatio: false,
            responsive: true,
            scales: {
                x: {
                    ticks: {
                        color: ChartColors.midnight500,
                        font: {
                            family: "Boston",
                            weight: "700",
                            size: 14,
                        },
                    },
                    grid: {
                        display: false,
                    },
                },
                y: {
                    border: {
                        display: false,
                    },
                    ticks: {
                        crossAlign: "far",
                        stepSize: data.step || undefined,
                        // Strips ',' to match the design. Adds a space as well otherwise
                        // it clips against the edge of th canvas for some reason.
                        callback: (string: string | number) => ` ${typeof string === "string" ? string.replace(",", "") : string}`,
                        color: ChartColors.pine700,
                        padding: 10,
                        font: {
                            family: "Boston",
                            weight: "700",
                            size: 14,
                        },
                    },
                    grid: {
                        display: false,
                    },
                },
            },
            plugins: {
                tooltip: {
                    backgroundColor: designTokens.colors.midnight[500],
                    displayColors: false,
                    xAlign: "center",
                    yAlign: "bottom",
                    padding: {
                        x: 12,
                        y: 8,
                    },
                    callbacks: {
                        title: () => "",
                        label: (context) => context.dataset.data[context.dataIndex]?.toString(),
                    },
                },
                legend: {
                    display: false,
                },
            },
        },
    });

export default createLineChart;
